export const Footer = () => {
    return (
        <section className="py-4 text-center text-secondary">
            &copy; 2024 - 2026 Khin Myo Wai
        </section>
    )
}